import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import { ErrorMessage } from '@/api'

export interface modalErrorParameterInterface {
  onOkClick?: any
}

@Module({
  name: 'ModalErrorStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalErrorStore extends BaseStore {
  _isOpen: boolean = false

  _okCallback: any

  _errorMessage: ErrorMessage | null = null

  get isOpen(): boolean {
    return this._isOpen
  }

  get errorMessage(): ErrorMessage | null {
    return this._errorMessage
  }

  @Mutation
  public init(errorMessage: ErrorMessage): void {
    this._errorMessage = errorMessage
  }

  @Mutation
  public open(params?: modalErrorParameterInterface): void {
    this._isOpen = true
    this._okCallback = params?.onOkClick
  }

  @Mutation
  public close(): void {
    this._isOpen = false
  }

  @Mutation
  public ok(): void {
    const result = this._okCallback ? this._okCallback() : true
    if (result === false) {
      return
    }

    this._isOpen = false
  }
}
